// NOTE: This module is currently unused in the site. It supports the TabbedTable
// widget in the Sitefinity project (SitefinityWebApp).

function init() {
  if (document.querySelector('.tabbed-table')) {
    $('.tabbed-table .anchors a').first().addClass('active');
    $('.tabbed-table table').first().addClass('active');

    $('.tabbed-table .anchors a').on('click', function (e) {
      e.preventDefault();
      $('.tabbed-table .anchors a, .tabbed-table table').removeClass('active');
      $(this).addClass('active');
      $('.tabbed-table table:nth-child(' + ($(this).index() + 1) + ')').addClass('active');
    });
  }
}

export { init }
